import {
  normalizeUTMConfig,
  parseUTMConfig,
} from 'src/components/lib/utm-config-editor/utils';
import type {UtmConfig, UtmConfigApi} from 'src/types/utm-config';


export function parseUtmConfig({
  utm_config = null,
}: {
  utm_config?: UtmConfigApi | null;
}): {utmConfig: UtmConfig | null} {
  const parsedUtmConfig = utm_config ? parseUTMConfig(utm_config) : null;
  return {utmConfig: parsedUtmConfig};
}

export function normalizeUtmConfig({
  utmConfig,
}: {
  utmConfig: UtmConfig | null;
}): {utm_config: UtmConfigApi | null} {
  const normalizedUtmConfig = utmConfig ? normalizeUTMConfig(utmConfig) : null;
  return {utm_config: normalizedUtmConfig};
}

export const getDefaultUtmConfigState = (): {
  utmConfig: UtmConfig | null;
} => ({
  utmConfig: null,
});
